import SettingsGear from './SettingsGear';

export default SettingsGear;
